import { Callout } from './Callout'

/**
 * "You are looking at a window, not the queue." (M24-T03)
 *
 * Four admin queues return only the newest 50 rows and, until this ticket, said
 * so nowhere. The cap itself is fine. What was not fine is that an empty result
 * had two possible meanings and no way to tell them apart:
 *
 *   1. that patient never called, or
 *   2. that patient called, and is row 62 of 214.
 *
 * A concierge acts differently on those two answers, so the page has to say
 * which one it is showing. This is the sentence that says it.
 *
 * It renders **nothing** when the list is complete. A permanent "showing all 12
 * of 12" is noise, and noise is what trains people to stop reading the line on
 * the day it matters.
 *
 * `Callout tone="info"` rather than a muted grey line: the ticket's own wording
 * is "a line you cannot miss while reading the rows it describes", and muted
 * grey above a table is exactly what an eye skips. It is not an alert — nothing
 * has gone wrong, and it must not steal focus.
 */
export function ListDisclosure({
  shown,
  total,
}: {
  /** Rows the server actually returned. */
  shown: number
  /** Rows matching the same scope and filter before the cap. `undefined` while
   *  loading, or from an endpoint that does not report one. */
  total: number | undefined
}) {
  if (total === undefined || total <= shown) return null
  return (
    <Callout tone="info">
      Showing the {shown} most recent of {total} — older ones are not on this
      page.
    </Callout>
  )
}
